export const DELIVERABLES_QUERY_KEY = "deliverables";

export { DELIVERABLE_STATUS_LABELS as STATUS_LABELS } from "apps/project-iq/constants/planStatusLabels";

export interface IDeliverablesPageProps {
  workspaceId: string;
  onDeliverableSaved?: () => void;
}
